import { render, staticRenderFns } from "./AvatarList.vue?vue&type=template&id=01ed95bc&"
import script from "./AvatarList.vue?vue&type=script&lang=js&"
export * from "./AvatarList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports